import axios from 'axios';
import * as Cookies from '../utils/cookies';
import * as Sentry from '@sentry/react';

export async function signIn(user, pass) {
  try {
    const res = await axios({
      method: 'POST', url: process.env.REACT_APP_API_URL + '/api-token-auth/', data: {
        phone_number: user, password: pass,
      },
    });
    const token = res.data.token;
    Cookies.setToken(token);


    Sentry.setContext('userData', {
      phone_number: user, env: process.env.NODE_ENV,
    });
    return token;
  } catch (error) {

    return { error: error.response?.data?.non_field_errors , hasError: true };
  }
}
